
  <h2 class="margin-top--none" >Automatisk stärkning</h2>
  @if (initiated) {
    <form (ngSubmit)="update(mmsGainDefaultValue, mmsGainDefaultVastValue)">
    <div class="input__container">
    <label>{{inputLabel()}}</label>
        <input name="mmsGainDefaultValue"
        [(ngModel)]="mmsGainDefaultValue"
        wooPercentFormatter
        [wooMinValidator]="0"
        [wooMaxValidator]="1">
    </div>
    <div class="input__container">
    <label>{{inputLabelVast()}}</label>
        <input name="mmsGainDefaultVastValue"
        [(ngModel)]="mmsGainDefaultVastValue"
        wooPercentFormatter
        [wooMinValidator]="0"
        [wooMaxValidator]="1">
    </div>
    <button
        type="Submit"
        class="button margin-top--3x"
        [disabled]=invalidMmsDefaultValue()
        wooLoad>Spara</button>
  </form>
}